import CryptoJS from 'crypto-js'
import type { ApiFileListType } from '@/types/config'

/**
 * 获取缓冲区数据 (加密的二进制数据)
 * 用于获取API文件列表等配置数据
 * @param path 请求路径
 * @returns Promise<ApiFileListType>
 */
export const fetchBufferData = async (path: string): Promise<ApiFileListType> => {
  const response = await fetch(path, {
    method: 'GET',
    headers: {
      Accept: '*/*',
      'Cache-Control': 'no-cache'
    }
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const arrayBuffer = await response.arrayBuffer()

  try {
    return JSON.parse(decryptArrayBuffer(arrayBuffer))
  } catch (error) {
    console.error(error, '解密失败:', path, decryptArrayBuffer(arrayBuffer))
    return []
  }
}

const key = '1234567890123456'
const iv = 'abcdefghijklmnop'

/**
 * ArrayBuffer 转 WordArray
 * 支持大型二进制数据
 */
function arrayBufferToWordArray(
  arrayBuffer: ArrayBuffer
): CryptoJS.lib.WordArray {
  const u8arr = new Uint8Array(arrayBuffer)
  const len = u8arr.length
  const words = []

  for (let i = 0; i < len; i += 4) {
    words.push(
      (u8arr[i] << 24) |
        ((u8arr[i + 1] ?? 0) << 16) |
        ((u8arr[i + 2] ?? 0) << 8) |
        (u8arr[i + 3] ?? 0)
    )
  }

  return CryptoJS.lib.WordArray.create(words, len)
}

/**
 * AES/CBC/PKCS7Padding 解密
 * @param arrayBuffer - 加密的二进制数据
 */
function decryptArrayBuffer(arrayBuffer: ArrayBuffer): string {
  try {
    // 1. 转换密钥和IV
    const keyWA = CryptoJS.enc.Utf8.parse(key)
    const ivWA = CryptoJS.enc.Utf8.parse(iv)

    // 2. ArrayBuffer转WordArray
    const encryptedWA = arrayBufferToWordArray(arrayBuffer)

    // 3. 创建CipherParams
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: encryptedWA
    })

    // 4. 解密
    const decrypted = CryptoJS.AES.decrypt(cipherParams, keyWA, {
      iv: ivWA,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })

    // 5. 转UTF-8字符串
    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (error) {
    console.error('解密失败:', error)
    throw error
  }
}
